import { render, staticRenderFns } from "./checkTemplate.vue?vue&type=template&id=5faeaa39&scoped=true&"
import script from "./checkTemplate.vue?vue&type=script&lang=js&"
export * from "./checkTemplate.vue?vue&type=script&lang=js&"
import style0 from "./checkTemplate.vue?vue&type=style&index=0&id=5faeaa39&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faeaa39",
  null
  
)

export default component.exports